import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  Input,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from '../../../../core/services/translate/translation.service';
import { ValidationHintComponent } from '../validation-hint/validation-hint.component';

@Component({
  selector: 'app-password-input',
  imports: [TranslateModule, ReactiveFormsModule, ValidationHintComponent],
  templateUrl: './password-input.component.html',
  styleUrl: './password-input.component.scss',
})
export class PasswordInputComponent implements AfterViewChecked {
  private readonly renderer = inject(Renderer2);
  private readonly translationService = inject(TranslationService);
  private readonly cd = inject(ChangeDetectorRef);

  @ViewChild('passwordInput') passwordInput!: ElementRef<HTMLInputElement>;

  @Input({ required: true })
  passwordControl!: FormControl<string>;

  @Input({ required: false })
  placeholder?: string;

  isFocused = false;
  showPassword = false;

  ngOnInit(): void {
    this.focusListener();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  lang = this.translationService.language();

  focusListener() {
    this.renderer.listen(
      'window',
      'click',
      (event: PointerEvent & { target: EventTarget & { id: string } }) => {
        if (!this.passwordInput) {
          this.isFocused = false;
          return;
        }
        if (event.target === this.passwordInput.nativeElement)
          this.isFocused = true;
        else this.isFocused = false;
      }
    );
  }

  showHidePassword() {
    this.showPassword = !this.showPassword;
  }

  randomNumber() {
    return Math.random() * 10;
  }
}
